import Cursos from 'containers/Matricula/Cursos'

export default function CursosPage() {
  return (
    <Cursos />
  );
}
